(function () {
    const articleContent = document.querySelector("[data-article-content]");
    if (!articleContent) {
        return;
    }

    articleContent.querySelectorAll("a[href]").forEach((link) => {
        const href = link.getAttribute("href")?.trim();

        if (!href || href.startsWith("#") || /^(?:mailto|tel|javascript):/i.test(href)) {
            return;
        }

        const rel = new Set((link.getAttribute("rel") || "").split(/\s+/).filter(Boolean));
        rel.add("noopener");
        rel.add("noreferrer");

        link.setAttribute("target", "_blank");
        link.setAttribute("rel", Array.from(rel).join(" "));
    });

    articleContent.querySelectorAll("table").forEach((table) => {
        if (table.closest(".gist") || table.parentElement?.classList.contains("gh-table-scroll")) {
            return;
        }

        const scroller = document.createElement("div");
        const caption = table.querySelector("caption")?.textContent.trim();

        scroller.className = "gh-table-scroll";
        scroller.tabIndex = 0;
        scroller.setAttribute("role", "region");
        scroller.setAttribute("aria-label", caption || "Scrollable table");

        table.parentNode.insertBefore(scroller, table);
        scroller.appendChild(table);
    });
})();

(function () {
    const categoryMenu = document.querySelector(".blog-category-menu");
    if (!categoryMenu) {
        return;
    }

    document.addEventListener("pointerdown", (event) => {
        if (categoryMenu.open && !categoryMenu.contains(event.target)) {
            categoryMenu.open = false;
        }
    }, true);

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && categoryMenu.open) {
            categoryMenu.open = false;
            categoryMenu.querySelector("summary")?.focus();
        }
    });
})();

(function () {
    const shareButton = document.querySelector("[data-share-button]");
    if (!shareButton) {
        return;
    }

    const label = shareButton.querySelector("[data-share-label]");
    const defaultLabel = label?.textContent.trim() || "Share";
    const shareTitle = shareButton.dataset.shareTitle || document.title;

    function setLabel(text) {
        if (label) {
            label.textContent = text;
        }
    }

    async function copyUrl(url) {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(url);
            return;
        }

        const field = document.createElement("textarea");
        field.value = url;
        field.setAttribute("readonly", "");
        field.style.position = "fixed";
        field.style.opacity = "0";
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand("copy");
        field.remove();

        if (!copied) {
            throw new Error("Copy unavailable");
        }
    }

    shareButton.addEventListener("click", async () => {
        const url = window.location.href;
        const useNativeShare = window.matchMedia("(pointer: coarse)").matches && typeof navigator.share === "function";

        if (useNativeShare) {
            try {
                await navigator.share({ title: shareTitle, url });
            } catch (_error) {
                // Cancelling the native share dialog is an expected user action.
            }
            return;
        }

        try {
            await copyUrl(url);
            setLabel("链接已复制");
            shareButton.setAttribute("aria-label", "链接已复制");
        } catch (_error) {
            setLabel("复制失败");
            shareButton.setAttribute("aria-label", "复制失败");
        }

        window.setTimeout(() => {
            setLabel(defaultLabel);
            shareButton.setAttribute("aria-label", defaultLabel);
        }, 1800);
    });
})();

(function () {
    const nav = document.querySelector("[data-home-filter-legacy-nav]");
    const feed = document.querySelector("[data-home-filter-feed]");
    if (!nav || !feed) {
        return;
    }

    const empty = document.querySelector("[data-home-filter-empty]");
    const links = Array.from(nav.querySelectorAll("[data-home-filter]"));
    let activeFilter = "all";
    let requestId = 0;

    function setActive(link) {
        links.forEach((item) => {
            const isActive = item === link;
            item.classList.toggle("is-active", isActive);
            item.setAttribute("aria-selected", isActive ? "true" : "false");
        });
    }

    function filterPosts(filter) {
        let visibleCount = 0;
        activeFilter = filter;

        feed.querySelectorAll("[data-post-tags]").forEach((post) => {
            const tags = (post.dataset.postTags || "").split(/\s+/).filter(Boolean);
            const isVisible = filter === "all" || tags.includes(filter);

            post.hidden = !isVisible;
            post.classList.toggle("is-home-filter-hidden", !isVisible);

            if (isVisible) {
                visibleCount += 1;
            }
        });

        if (empty) {
            empty.hidden = visibleCount !== 0;
        }
    }

    async function selectFilter(link) {
        const filter = link.dataset.homeFilter;
        if (!filter) {
            return;
        }

        setActive(link);
        activeFilter = filter;
        feed.setAttribute("aria-busy", "true");
        const filterUrl = new URL(link.dataset.homeFilterUrl || link.href, window.location.href);
        const requestUrl = `${filterUrl.pathname}${filterUrl.search}`;

        const currentRequest = requestId + 1;
        requestId = currentRequest;

        try {
            const response = await fetch(requestUrl, {credentials: "same-origin"});
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, "text/html");
            const nextFeed = doc.querySelector(".post-feed.gh-feed");

            if (!response.ok || !nextFeed) {
                window.location.href = filterUrl.href;
                return;
            }

            if (currentRequest !== requestId) {
                return;
            }

            feed.innerHTML = nextFeed.innerHTML;

            const nextPagination = doc.querySelector(".blog-pagination");
            const currentPagination = document.querySelector(".blog-pagination");

            if (nextPagination && currentPagination) {
                currentPagination.innerHTML = nextPagination.innerHTML;
            }

            filterPosts(filter);
        } catch (error) {
            window.location.href = filterUrl.href;
        } finally {
            if (currentRequest === requestId) {
                feed.removeAttribute("aria-busy");
            }
        }
    }

    links.forEach((link) => {
        link.setAttribute("role", "tab");
        link.setAttribute("aria-selected", link.classList.contains("is-active") ? "true" : "false");

        link.addEventListener("click", (event) => {
            event.preventDefault();
            void selectFilter(link);
        });
    });

    const requestedHash = window.location.hash.match(/^#category-(.+)$/);
    const requestedFilter = new URLSearchParams(window.location.search).get("category")
        || (requestedHash ? decodeURIComponent(requestedHash[1]) : null);
    const requestedLink = links.find((link) => link.dataset.homeFilter === requestedFilter);
    if (requestedLink) {
        void selectFilter(requestedLink);
    }

    const observer = new MutationObserver(() => {
        filterPosts(activeFilter);
    });
    observer.observe(feed, {childList: true});
})();

(function () {
    const modal = document.getElementById("shortmind-search");
    const openButton = document.querySelector("[data-sm-search-open]");
    if (!modal || !openButton) {
        return;
    }

    const panel = modal.querySelector(".sm-search-panel");
    const closeButton = modal.querySelector(".sm-search-close");
    const form = modal.querySelector(".sm-search-form");
    const input = modal.querySelector(".sm-search-input");
    const status = modal.querySelector(".sm-search-status");
    const results = modal.querySelector(".sm-search-results");
    const labels = {
        empty: modal.dataset.labelEmpty || "Start typing to search",
        loading: modal.dataset.labelLoading || "Preparing search index...",
        none: modal.dataset.labelNone || "No matching posts found",
        error: modal.dataset.labelError || "Search index failed to load",
        foundPrefix: modal.dataset.labelFoundPrefix || "Found",
        foundSuffix: modal.dataset.labelFoundSuffix || "matching posts"
    };
    let posts = [];
    let hasLoaded = false;

    function setStatus(text) {
        status.textContent = text;
    }

    function normalize(value) {
        return (value || "").toString().trim();
    }

    function loadPosts() {
        if (hasLoaded) {
            return;
        }

        hasLoaded = true;
        setStatus(labels.loading);

        try {
            posts = Array.from(modal.querySelectorAll(".sm-search-index article")).map((item) => {
                const title = normalize(item.dataset.title);
                const excerpt = normalize(item.dataset.excerpt);
                const tags = normalize(item.dataset.tags);

                return {
                    title,
                    url: normalize(item.dataset.url),
                    excerpt,
                    date: normalize(item.dataset.date),
                    tags,
                    haystack: [title, excerpt, tags].join(" ").toLowerCase()
                };
            }).filter((post) => post.title && post.url);

            setStatus(labels.empty);
        } catch (_error) {
            posts = [];
            setStatus(labels.error);
        }
    }

    function formatDate(value) {
        if (!value) {
            return "";
        }

        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).format(new Date(value));
    }

    function renderResults(query) {
        const keyword = query.trim().toLowerCase();
        results.textContent = "";

        if (!keyword) {
            setStatus(labels.empty);
            return;
        }

        const matches = posts.filter((post) => post.haystack.includes(keyword)).slice(0, 8);

        if (!matches.length) {
            setStatus(labels.none);
            return;
        }

        setStatus(`${labels.foundPrefix} ${matches.length} ${labels.foundSuffix}`);

        matches.forEach((post) => {
            const link = document.createElement("a");
            const title = document.createElement("span");
            const meta = document.createElement("span");
            const excerpt = document.createElement("span");
            const firstTag = post.tags.split(",").map((tag) => tag.trim()).filter(Boolean)[0] || "";

            link.className = "sm-search-result";
            link.href = post.url;
            link.setAttribute("role", "listitem");

            title.className = "sm-search-result-title";
            title.textContent = post.title;

            meta.className = "sm-search-result-meta";
            meta.textContent = [firstTag, formatDate(post.date)].filter(Boolean).join(" / ");

            excerpt.className = "sm-search-result-excerpt";
            excerpt.textContent = post.excerpt;

            link.append(title, meta, excerpt);
            results.appendChild(link);
        });
    }

    function openSearch() {
        modal.hidden = false;
        modal.setAttribute("aria-hidden", "false");
        loadPosts();
        renderResults(input.value);
        window.setTimeout(() => input.focus(), 0);
    }

    function closeSearch() {
        modal.hidden = true;
        modal.setAttribute("aria-hidden", "true");
        input.value = "";
        results.textContent = "";
        setStatus(labels.empty);
        openButton.focus();
    }

    openButton.addEventListener("click", openSearch);
    closeButton.addEventListener("click", closeSearch);
    form.addEventListener("submit", (event) => event.preventDefault());
    input.addEventListener("input", () => renderResults(input.value));

    modal.addEventListener("click", (event) => {
        if (!panel.contains(event.target)) {
            closeSearch();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !modal.hidden) {
            closeSearch();
        }
    });
})();

(function () {
    function setImportant(element, property, value) {
        element.style.setProperty(property, value, "important");
    }

    function isMemberCta(element) {
        const className = element.className || "";
        if (typeof className !== "string") {
            return false;
        }

        return (
            element.matches(".gh-post-upgrade-cta, .gh-post-upgrade-cta-content") ||
            className.includes("post-upgrade") ||
            className.includes("upgrade-cta") ||
            className.includes("member-cta")
        );
    }

    function styleMemberCta(element) {
        if (element.closest(".sm-member-cta")) {
            return;
        }

        element.dataset.shortmindMemberStyled = "true";
        setImportant(element, "display", "none");
    }

    function findMemberCtaByContent(root = document) {
        const candidates = Array.from(root.querySelectorAll("main div, main section, .site-content div, .site-content section"));

        candidates.forEach((element) => {
            if (element.dataset.shortmindMemberStyled === "true") {
                return;
            }

            const text = element.textContent || "";
            const hasPortalAction = element.querySelector('[href*="#/portal"], [data-portal], button');
            const hasSignupText = text.includes("立即注册") || text.includes("注册") || text.includes("Subscribe") || text.includes("Sign up");
            const hasSigninText = text.includes("登录") || text.includes("Sign in");

            if (!hasPortalAction || !hasSignupText || !hasSigninText) {
                return;
            }

            const rect = element.getBoundingClientRect();
            if (rect.width < 280 || rect.height < 80) {
                return;
            }

            let target = element;
            let parent = element.parentElement;

            while (parent && parent.matches("main div, main section, .site-content div, .site-content section")) {
                const parentText = parent.textContent || "";
                const parentRect = parent.getBoundingClientRect();

                if (
                    parentText.includes(text.trim()) &&
                    parentRect.width >= rect.width &&
                    parentRect.height <= Math.max(rect.height + 180, rect.height * 2.2)
                ) {
                    target = parent;
                    parent = parent.parentElement;
                    continue;
                }

                break;
            }

            styleMemberCta(target);
        });
    }

    function isPortalFrame(element) {
        if (!element.matches("iframe")) {
            return false;
        }

        const marker = `${element.className || ""} ${element.title || ""} ${element.src || ""}`.toLowerCase();
        return marker.includes("portal") || marker.includes("signup") || marker.includes("signin");
    }

    function stylePortalFrame(frame) {
        setImportant(frame, "background", "transparent");
        setImportant(frame, "background-color", "transparent");
        setImportant(frame, "color-scheme", "dark");
        setImportant(frame, "filter", "none");
        injectPortalFrameStyle(frame);
        frame.addEventListener("load", () => injectPortalFrameStyle(frame), { once: false });
    }

    function injectPortalFrameStyle(frame) {
        const portalCss = `
            html,
            body {
                background: transparent !important;
                background-color: transparent !important;
                color-scheme: dark !important;
            }

            body > div,
            body > div > div:first-child,
            [class*="background"],
            [class*="Backdrop"],
            [class*="backdrop"],
            [class*="Overlay"],
            [class*="overlay"] {
                background: transparent !important;
                background-color: transparent !important;
                backdrop-filter: none !important;
                -webkit-backdrop-filter: none !important;
            }

            body > div::before,
            body > div::after {
                background: transparent !important;
                background-color: transparent !important;
            }

            [class*="modal"],
            [class*="Modal"],
            [class*="popup"],
            [class*="Popup"],
            [class*="container"],
            [class*="Container"],
            form {
                border-color: rgba(255, 255, 255, 0.06) !important;
                background: rgba(12, 13, 16, 0.98) !important;
                background-color: rgba(12, 13, 16, 0.98) !important;
                color: #f8fafc !important;
                box-shadow: 0 24px 72px rgba(0, 0, 0, 0.32) !important;
            }

            input {
                border-color: rgba(255, 255, 255, 0.08) !important;
                background: rgba(255, 255, 255, 0.045) !important;
                color: #f8fafc !important;
            }

            h1,
            h2,
            h3,
            label,
            p,
            span,
            a,
            button {
                color: #f8fafc !important;
            }
        `;

        try {
            const doc = frame.contentDocument || frame.contentWindow?.document;
            if (!doc) {
                return;
            }

            let style = doc.getElementById("shortmind-portal-skin");
            if (!style) {
                style = doc.createElement("style");
                style.id = "shortmind-portal-skin";
                (doc.head || doc.documentElement).appendChild(style);
            }

            style.textContent = portalCss;

            doc.querySelectorAll('[class*="background"], [class*="Backdrop"], [class*="backdrop"], [class*="Overlay"], [class*="overlay"]').forEach((element) => {
                setImportant(element, "background", "transparent");
                setImportant(element, "background-color", "transparent");
                setImportant(element, "backdrop-filter", "none");
                setImportant(element, "-webkit-backdrop-filter", "none");
            });
        } catch (_error) {
            // Portal can be isolated in an iframe; outer-frame styles still apply when inner CSS is inaccessible.
        }
    }

    function stylePortalLayers(root = document) {
        root.querySelectorAll('[class*="portal"][class*="background"], [class*="portal"][class*="overlay"]').forEach((element) => {
            setImportant(element, "background", "transparent");
            setImportant(element, "background-color", "transparent");
            setImportant(element, "backdrop-filter", "none");
            setImportant(element, "-webkit-backdrop-filter", "none");
        });
    }

    function skinMemberSurfaces(root = document) {
        root.querySelectorAll(".gh-post-upgrade-cta, .gh-post-upgrade-cta-content, [class*='post-upgrade'], [class*='upgrade-cta'], [class*='member-cta']").forEach((element) => {
            if (isMemberCta(element)) {
                styleMemberCta(element);
            }
        });

        root.querySelectorAll("iframe").forEach((frame) => {
            if (isPortalFrame(frame)) {
                stylePortalFrame(frame);
            }
        });

        stylePortalLayers(root);
        findMemberCtaByContent(root);
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) {
                    return;
                }

                if (isMemberCta(node)) {
                    styleMemberCta(node);
                }

                if (isPortalFrame(node)) {
                    stylePortalFrame(node);
                }

                skinMemberSurfaces(node);
            });
        });
    });

    skinMemberSurfaces();
    window.setTimeout(skinMemberSurfaces, 250);
    window.setTimeout(skinMemberSurfaces, 1000);
    window.setInterval(skinMemberSurfaces, 2000);
    observer.observe(document.documentElement, { childList: true, subtree: true });
})();
